export enum CreditCardTypes {
    amex = "amex",
    discover = "discover",
    mastercard = "mastercard",
    visa = "visa",
    unknown = "unknown",
}